;(function($){

    function CustomersCommissions() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });

        if($("#modal-customers-commissions").length > 0) {

            $("#modal-customers-commissions").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                   _.getProviders();
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    _.html = '<form id="form-customers-commissions" enctype="multipart/form-data">'+
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="providers_id">Fornecedor</label>' +
                                '<select name="providers_id" id="providers_id" disabled></select>' +
                            '</div>'+
                        '</div>'+
                    '</div>' +
                   '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="percentage">Percentual</label>' +
                                '<input type="text" id="percentage" name="percentage" data-percentage>' +
                            '</div>'+
                        '</div>'+                           
                   '</div>'+         
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<input type="hidden" id="customers_id" name="customers_id" value="'+_.customers_id+'">' +
                                '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                            '</div>'+
                        '</div>'+                             
                   '</div></form>';

                    if(_.html != ""){
                    $('#modal-customers-commissions').iziModal('setTitle', 'Adicionar Comissionamento');
                    $("#modal-customers-commissions .content").html(_.html);
                    $('[data-percentage]').mask('##0.00', {reverse: true});

                    _.myForm = $("#form-customers-commissions").validate({
                        rules: {
                            providers_id: { required: true },
                            percentage: { required: true }
                        },
                        messages: {
                            providers_id: { required: "Campo Obrigatório" },
                            percentage: { required: "Campo Obrigatório" }
                        },
                        invalidHandler: function(e) {
                            swal({
                                title: "Atenção!",
                                text: "Preencha todos os campos.",
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "OK!",
                                closeOnConfirm: true
                            });

                        },
                        submitHandler: function( form ) {
                        
                            $("#form-customers-commissions .btn-send").html("Enviando...");
                            
                            $.ajax({
                                type: "POST",
                                url: _.API + "clientes/comissionamento/novo",
                                cache: false,
                                contentType: false,
                                processData: false,
                                data: new FormData(form),
                                success: function(result)
                                {
                                    $("#form-customers-commissions .btn-send").html("Enviar");

                                    form.reset();

                                    $('#modal-customers-commissions').iziModal('close'); 

                                    swal({
                                        title: result.message,
                                        text: "Click no botão para fechar!",
                                        type: "success",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Fechar!",
                                        closeOnConfirm: false
                                    }).then(function() {
                                      location = location+"#commissions";

                                      location.reload(true);
                                    });                                        
                                },
                                error: function(response) {
                                    var errors = $.parseJSON(response.responseText);
                                    
                                    swal({
                                        title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                        text: "Click no botão para fechar!",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Fechar!",
                                        closeOnConfirm: true
                                    });

                                   
                                    $myForm.showErrors(errors);
                                    
                                    $("#form-customers-commissions .btn-send").html("Enviar");
                                }
                            });
                        }
                    });
                }                
                },
                onClosed: function() {
                    _.uri          = null;
                    _.customers_id = null;
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-customers-commissions .content").html("");
                    $('#modal-customers-commissions').iziModal('setTitle', "");
                }        
            });
        }

        $("button.btn-create-customers-commissions ").on("click", function(e){
            e.preventDefault();
            _.customers_id = $(this).data('customer');
            $('#modal-customers-commissions').iziModal('open');           
        });
    }  

    CustomersCommissions.prototype.getProviders = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/fornecedores", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#providers_id").attr('disabled', false).html(html);
            $("select#providers_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });           
        });
    }; 

   	new CustomersCommissions();

}(jQuery));